import { render } from "./mutiple-pictures.vue?vue&type=template&id=7e454df7&scoped=true"
import script from "./mutiple-pictures.vue?vue&type=script&lang=js"
export * from "./mutiple-pictures.vue?vue&type=script&lang=js"

import "./mutiple-pictures.vue?vue&type=style&index=0&id=7e454df7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e454df7"]])

export default __exports__